import { SxProps, Theme } from "@mui/material";

export const containerStyle: SxProps<Theme> = {
  display: "inline-flex",
  alignItems: "center",
  gap: { xs: 0.75, sm: 1 },
  px: { xs: 1.25, sm: 2 },
  py: { xs: 0.5, sm: 1 },
  borderRadius: "999px",
  border: "1px solid rgba(6, 182, 212, 0.22)",
  backgroundColor: "transparent",
  color: "#06B6D4",
  flexShrink: 0,
  minWidth: 0,
};

export const iconStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

export const textStyle: SxProps<Theme> = {
  fontSize: { xs: "12px", sm: "14px" },
  fontWeight: 600,
  lineHeight: 1.2,
  whiteSpace: "nowrap",
};
